const SNX = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#1E1A31" />
    <path
      d="M13.1921 5.46755H13.9686L6.93166 14.5426H6.15517L13.1921 5.46755Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7559 9.25968C10.9489 9.26462 11.1324 9.34479 11.2672 9.48309C11.4021 9.62139 11.4775 9.80687 11.4775 10C11.4775 10.1931 11.4021 10.3786 11.2672 10.5169C11.1324 10.6552 10.9489 10.7354 10.7559 10.7403H8.84133C7.95449 10.7297 7.10759 10.3699 6.48423 9.73906C5.86088 9.10819 5.5113 8.25704 5.5113 7.37016C5.5113 6.48328 5.86088 5.63214 6.48423 5.00127C7.10759 4.3704 7.95449 4.01064 8.84133 4H13.7784C13.9714 4.00494 14.1549 4.08511 14.2897 4.22341C14.4246 4.36171 14.5 4.5472 14.5 4.74032C14.5 4.93345 14.4246 5.11894 14.2897 5.25724C14.1549 5.39554 13.9714 5.47571 13.7784 5.48065H8.84133C8.34019 5.48065 7.85958 5.67972 7.50522 6.03407C7.15086 6.38843 6.95178 6.86903 6.95178 7.37016C6.95178 7.87129 7.15086 8.3519 7.50522 8.70625C7.85958 9.0606 8.34019 9.25968 8.84133 9.25968H10.7559Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.24461 10.7403C9.05154 10.7354 8.86805 10.6552 8.73324 10.5169C8.59843 10.3786 8.52299 10.1931 8.52299 10C8.52299 9.80687 8.59843 9.62139 8.73324 9.48309C8.86805 9.34479 9.05154 9.26462 9.24461 9.25968H11.1592C12.046 9.27032 12.8929 9.63007 13.5163 10.2609C14.1396 10.8918 14.4892 11.743 14.4892 12.6298C14.4892 13.5167 14.1396 14.3679 13.5163 14.9987C12.8929 15.6296 12.046 15.9894 11.1592 16H6.22162C6.02856 15.9951 5.84506 15.9149 5.71025 15.7766C5.57545 15.6383 5.5 15.4528 5.5 15.2597C5.5 15.0665 5.57545 14.8811 5.71025 14.7428C5.84506 14.6045 6.02856 14.5243 6.22162 14.5194H11.1592C11.6603 14.5194 12.1409 14.3203 12.4953 13.9659C12.8496 13.6116 13.0487 13.131 13.0487 12.6298C13.0487 12.1287 12.8496 11.6481 12.4953 11.2938C12.1409 10.9394 11.6603 10.7403 11.1592 10.7403H9.24461Z"
      fill="white"
    />
  </svg>
);
export default SNX;
